/* eslint-disable react/no-danger */
import { observer } from 'mobx-react';

// Components
import { Typography } from 'top-component-library';

// Constants
import DOMPurify from 'dompurify';
import { TitleContainer } from './styles';

const Title = ({ className, titleText }: { className: string; titleText: string }): any => (
  <TitleContainer className={className}>
    <Typography.Title>
      <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(titleText) }} />
    </Typography.Title>
  </TitleContainer>
);

export default observer(Title);
